import { Inject, Pipe, PipeTransform } from '@angular/core';
import { BASE_OMS_URL } from 'src/app/injection-tokens';

@Pipe({
  name: 'omsInvoiceLink',
})
export class OmsInvoiceLinkPipe implements PipeTransform {
  constructor(@Inject(BASE_OMS_URL) readonly baseOMSUrl: string) {}

  transform(invoiceId: unknown, ...args: unknown[]): unknown {
    return `${this.baseOMSUrl}invoice/${invoiceId}`;
  }
}
